import { useQuery } from '@tanstack/react-query';
import { Challenge } from 'types';
import { getQuestCompletions } from '../API';

export const completedQuestsQueryKey = 'completed-quests';

export function useGetCompletedQuests(challengeId: Challenge['id']) {
  return useQuery([completedQuestsQueryKey, challengeId], () => getQuestCompletions(challengeId));
}
